import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { ButtonCusWithIcon } from '@/components/common/Button';
import { useStore } from '@/hooks/useStore';
import ChangePasswordForm from './ChangePasswordForm';

export default observer(function PasswordItem() {
    // hook
    const { t } = useTranslation();

    // store
    const {
        modalStore: { showAlertModal }
    } = useStore();

    // function
    const onClickBtnChangePassword = () => {
        showAlertModal({
            id: 'change-password-modal',
            title: t('words_title.change_password'),
            size: 'xl',
            titleClassName: 'text-center max-w-none',
            content: (
                <ChangePasswordForm idModal='change-password-modal' />
            ),
            footerClassName: 'hidden'
        });
    };

    return (
        <ButtonCusWithIcon
            type='button'
            size='default'
            variant='default'
            className='w-fit gap-1.5 whitespace-nowrap h-9.5 px-2 md:h-12 md:px-4'
            onClick={onClickBtnChangePassword}
            iconId='#icon-change-password'
            widthIcon={16}
            heightIcon={22}
        >
            {t('words_title.change_password')}
        </ButtonCusWithIcon>
    );
});
